module.exports = __webpack_public_path__ + "static/media/logo.02babb47.png";